$(function () {

    var show = true;

    $.nette.ext('frontendPopupAjaxExtension', {
        before:  function () {

        },
        success: function () {
            var close = $('#newsletter-register-form-setting').data('close-modal');
            var target = $('#newsletter-register-form-setting').data('close-modal-target');
            var delay = $('#newsletter-register-form-setting').data('close-modal-delay');

            if (close && target) {
                if (delay) {
                    setTimeout(function () {
                        $(target).modal('hide');
                    }, delay)

                    return;
                }

                $(target).modal('hide');
            }
        }
    });

    $(document).on('scroll', function () {
        var close = $('#newsletter-register-form-setting').data('close-modal');

        if (!show) {
            return;
        }

        $('#banner-popup').modal('show');
        if ($('#banner-popup').length && close !== undefined) {
            createCookie('popup', 'true');
        }

        $('.js-modal-overlay').addClass( 'active' );
        $('#banner-popup-image').addClass( 'active' );
        if ($('#banner-popup-image').hasClass('active')) {
            createCookie('popup', 'true', 1);
        }

        show = false;
    });

});


function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}